import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type { TGetEmpreendimentosDisponiveisResponse } from '@/features/empreendimentos/interfaces/empreendimento.types'
import { GetEmpreendimentosDisponiveisService } from '@/features/empreendimentos/services/get-empreendimentos-disponiveis.service'
import { empreendimentosKeys } from '@/features/empreendimentos/utils'

export const useEmpreendimentosDisponiveis = (params?: { apenasFuturo: boolean; enabled: boolean }) => {
  return useQuery<TGetEmpreendimentosDisponiveisResponse, AxiosError>({
    queryKey: empreendimentosKeys.disponiveis(params?.apenasFuturo),
    enabled: params?.enabled,
    initialData: [],
    queryFn: () =>
      new GetEmpreendimentosDisponiveisService().execute(params?.apenasFuturo).then((response) => response.data),
  })
}
